// ZoomSlider.js
export default class ZoomSlider {
    constructor(map) {
        this.map = map

        this.slider = document.getElementById('zoomSlider')
        this.valueEl = document.querySelector('.zoom-value')

        this.isUpdatingFromMap = false
        this.isUpdatingFromSlider = false

        this.init()
    }

    init() {
        // Initialisation bornes depuis la map
        this.slider.min = this.map.getMinZoom()
        this.slider.max = this.map.getMaxZoom()
        this.slider.step = 0.01

        // Sync initiale
        this.updateFromMap()

        // Slider -> Map
        this.slider.addEventListener('input', () => {
            if (this.isUpdatingFromMap) return

            this.isUpdatingFromSlider = true

            const zoom = parseFloat(this.slider.value)
            this.map.zoomTo(zoom, { duration: 0 })

            this.valueEl.textContent = zoom.toFixed(2)

            this.isUpdatingFromSlider = false
        })

        // Map -> Slider
        this.map.on('zoom', () => {
            if (this.isUpdatingFromSlider) return

            this.isUpdatingFromMap = true

            this.updateFromMap()

            this.isUpdatingFromMap = false
        })
    }

    updateFromMap() {
        const zoom = this.map.getZoom()
        this.slider.value = zoom
        this.valueEl.textContent = zoom.toFixed(2)
    }
}